export const BLOG_POSTS = [
  {
    slug: 'alternative-kahoot-gratuite',
    title: '5 alternatives à Kahoot pour ta classe en 2026',
    excerpt:
      'Tu cherches une alternative à Kahoot ? Voici 5 outils de quiz interactifs comparés honnêtement — forces, limites et à qui ils s\'adressent vraiment.',
    description:
      'KartQuiz, Quizizz, Wooclap, Blooket, Mentimeter : comparatif honnête des 5 meilleures alternatives à Kahoot en 2026. Forces, limites, tarifs et cas d\'usage.',
    date: '2026-05-03',
    readTime: '7 min',
    tags: ['comparatif', 'kahoot', 'quiz'],
    toc: [
      { id: 'pourquoi-chercher-une-alternative-à-kahoot', label: 'Pourquoi chercher une alternative ?' },
      { id: '1-kartquiz--la-course-interactive',         label: '1. KartQuiz' },
      { id: '2-quizizz--le-self-paced',                  label: '2. Quizizz' },
      { id: '3-wooclap--les-grandes-audiences',          label: '3. Wooclap' },
      { id: '4-blooket--les-mini-jeux-variés',           label: '4. Blooket' },
      { id: '5-mentimeter--les-présentations-interactives', label: '5. Mentimeter' },
      { id: 'tableau-récapitulatif',                     label: 'Tableau récapitulatif' },
      { id: 'comment-choisir',                           label: 'Comment choisir ?' },
    ],
  },
  {
    slug: 'reviser-brevet-quiz-interactif',
    title: 'Réviser le brevet : 8 façons de transformer une heure de cours en révisions efficaces',
    excerpt:
      'Fin d\'année, tes 3ème ont la tête ailleurs. Voici 8 techniques actives pour rendre les révisions du brevet engageantes — dont une qui transforme ton cours en course de kart.',
    description:
      'Réviser le brevet autrement : 8 techniques actives pour tes 3ème — quiz gamifié, répétition espacée, défi chronométré, enseignement par les pairs et plus.',
    date: '2026-05-03',
    readTime: '8 min',
    tags: ['brevet', 'révision', 'pédagogie'],
    toc: [
      { id: 'le-problème-des-révisions-passives',        label: 'Le problème des révisions passives' },
      { id: '1-le-quiz-interactif-gamifié',              label: '1. Le quiz gamifié' },
      { id: '2-la-répétition-espacée-flash-révision',    label: '2. La répétition espacée' },
      { id: '3-le-défi-chronométré-speed-review',        label: '3. Le défi chronométré' },
      { id: '4-le-jeu-de-questions-entre-élèves',        label: '4. Le jeu de questions' },
      { id: '5-la-carte-mentale-collaborative',          label: '5. La carte mentale' },
      { id: '6-lenseignement-par-les-pairs-peer-teaching', label: '6. Enseignement par les pairs' },
      { id: '7-la-simulation-dexamen',                   label: '7. La simulation d\'examen' },
      { id: '8-le-récap-vidéo-courte-2-minutes-max',     label: '8. Le récap vidéo' },
      { id: 'conclusion--et-concrètement-par-où-commencer', label: 'Conclusion' },
    ],
  },
]
